import { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Essence from './components/Essence';
import Solutions from './components/Solutions';
import Differential from './components/Differential';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import ContactForm from './components/ContactForm';

export default function Home() {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar onOpenContact={() => setIsContactOpen(true)} />
      <Hero />
      <Essence />
      <Solutions />
      <Differential />
      <FinalCTA onOpenContact={() => setIsContactOpen(true)} />
      <Footer />
      {isContactOpen && (
        <ContactForm onClose={() => setIsContactOpen(false)} />
      )}
    </div>
  );
}
